module.exports = __webpack_public_path__ + "img/cart-img.2828605b.png";